import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  button {
    height: 34px;
    min-width: 180px;
    color: ${colors.textButton};
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    border-radius: 3px;
    background-color: transparent;
    text-transform: uppercase;
    cursor: pointer;
    font-family: Roboto;

    @media (max-width: 1024px) {
      width: 100%;
    }
  }

  button:hover {
    color: white;
    background-color: ${colors.backgroundButton};
    border: none !important;
  }

  button:disabled {
    color: ${colors.textButtonDisable};
    background-color: transparent;
    border: 1px solid ${colors.greyishBrown} !important;
  }

  button.bordered {
    border: 1px solid ${colors.tangerine};
  }
  button.bordered:hover {
    border: 1px solid ${colors.textButton};
  }

  .noborder {
    border: none;
  }

  .noborder:hover {
    border: none;
    background-color: transparent !important;
    color: black;
  }

  .secondary {
    color: ${colors.textButtonSecondary};
  }

  button.secondary:hover {
    color: white;
    background-color: ${colors.backgroundButton2};
    border: none !important;
  }

  button.secondary:disabled {
    color: ${colors.textButtonDisable};
    background-color: transparent;
    border: 1px solid ${colors.greyishBrown} !important;
  }

  button.bordered--secondary {
    border: 1px solid black;
  }
  button.bordered--secondary:hover {
    border: 1px solid ${colors.textButtonSecondary};
  }
`;

export { Wrapper };



// WEBPACK FOOTER //
// ./src/components/Button/style.js